module.exports = __webpack_public_path__ + "static/media/case-study-icb.756ee6c0.jpg";